import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import lodashMap from 'lodash/map';
import lodashFilter from 'lodash/filter';
// import PropTypes from 'prop-types';
import { Row, Grid, Panel, Tabs, Tab, Breadcrumb } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';

import ContentWrapper from '../../Layout/ContentWrapper';
import SpinnerButton from '../../Common/SpinnerButton';
import ConfirmActionModal from '../../Common/confirmActionModal';
import Spinner from '../../Widgets/spinner';
import {
  desiredShapeByQuantity,
  desiredShapeBuyAGetB,
  desiredShapeByTotalPriceProduct,
  desiredShapeByTotalPriceDiscount,
  cleanProduct,
  clearForm,
  isIncompleteForm,
} from './utils';
import {
  PromotionsTable,
  PromotionSetup,
  PromotionsProductSearch,
  BuyAGetBProductSearches,
  ByQuantityFields,
  ByTotalPriceProductFields,
  BuyAGetBFields,
  ByTotalPriceDiscountFields,
  EditPromotionModal,
  BuyMixAGetBProductSearches,
} from './components';

import { fetchPromotions, fetchPromoDetails, savePromotion, deletePromotion, fetchGroups, fetchGroupCategories, } from '../../../actions/promotions_actions';
import { fetchCustomerGroups } from '../../../actions/groupList_actions';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isOLG, isLMH, isSDR, isCRW, isGFD, isSC } from '../../../actions/root_url';

const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';

// const propTypes = {
// };

// const defaultProps = {
// };

class PromotionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerList: [],
      promotions: [],
      promotionsTableData: {
        rows: [],
        selectedRows: null,
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      isLoadingPromotions: false,
      isLoadingSavePromotion: false,
      isLoadingPromoDetails: false,

      startDateSelected: null,
      endDateSelected: null,
      customerGroupSelected: '',
      paymentTypeSelected: '',

      tabsKey: 'ByQuantity',
      suggestValue: '',
      productSearchType: 'ProductNum',
      selectedProduct: {},

      groupList: [],
      categoryList: [],
      selectedGroup: '',
      selectedCategory: '',
      
      methodSelected: '',
      discountValue: '',
      discountType: 'Dollar',
      quantityFrom: '',
      quantityTo: '',

      applyLv1: true,
      applyLv2: true,
      applyLv3: true,
      applyLv4: true,
      applyLv5: true,

      minPurchasePrice: '',

      productQuantityA: '',
      productQuantityB: '',

      promoCode: '',
      autoApply: true,
      IsOneTime: false,
      IsPublic: true,

      suggestValueA: '',
      productSearchTypeA: 'ProductNum',
      selectedProductA: '',

      suggestValueB: '',
      productSearchTypeB: 'ProductNum',
      selectedProductB: '',

      editPromotionOpen: false,
      deletePromotionOpen: false,
      confirmProductRepeatOpen: false,
      promotionToEdit: {},
      promotionToDeleteId: undefined,

      SalesType: 'all',
      
      promotedPrice: "",
      selectedProductMixA: []
    };
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    this.handleFetchCustomerGroups();
    this.handleFetchPromotions(this.props.selectedCompany);
    this.handleFetchGroups();
    this.initData();
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.selectedCompany !== nextProps.selectedCompany) {
      this.handleFetchPromotions(nextProps.selectedCompany);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.tabsKey !== prevState.tabsKey) {
      this.setState({
        promotedPrice: '',
        discountValue: '',
      })
    }
  }

  initData = () => {
    if (isGFD) {
      this.setState({
        paymentTypeSelected: 'POS'
      })
    }
  }
  getCustomerOptions = () => {
    const { customerList } = this.state;
    const customerOptions = [{ value: 'All', label: <Translate value="all" /> }];
    lodashMap(customerList, (customer) => {
      const option = { value: customer.Name, label: customer.Name };
      customerOptions.push(option);
    });
    return customerOptions;
  }
  
  // when click group, gtt category options
  getGroupOptions = () => {
    const { groupList } = this.state;
    // const groupOptions = [{ value: 'All', label: 'All' }];
    const groupOptions = [{value: -1, label: <Translate value="all" /> }];
    lodashMap(groupList, (group) => {
      const option = { value: group.ProductGroup_id, label: group.Name };
      groupOptions.push(option);
    });
    return groupOptions;
  }
  
  getCategoryOptions = () => {
    const { categoryList } = this.state;
    const categoryOptions = [{ value: -1, label: <Translate value="all" />  }];
    
    lodashMap(categoryList, (category) => {
      const option = { value: category.ProductCategory_id, label: category.Name };
      categoryOptions.push(option);
    });
    return categoryOptions;
  }

  setStartDate = (e) => {
    if (this.state.endDateSelected && e > this.state.endDateSelected) {
      alert(I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
      return;
    }
    this.setState({ startDateSelected: e });
  }

  setEndDate = (e) => {
    if (this.state.startDateSelected && e < this.state.startDateSelected) {
      alert(I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
      return;
    }
    this.setState({ endDateSelected: e });
  }

  openEditPromotion = () => {
    this.setState({ editPromotionOpen: true });
  }

  closeEditPromotion = (refresh) => {
    this.setState({ editPromotionOpen: false }, () => {
      if (refresh) {
        this.handleFetchPromotions(this.props.selectedCompany);
      }
    });
  }

  openDeletePromotion = (promotionToDeleteId) => {
    this.setState({ deletePromotionOpen: true, promotionToDeleteId });
  }

  closeDeletePromotion = () => {
    this.setState({ deletePromotionOpen: false });
  }

  handleFetchCustomerGroups = () => {
    const handleSuccess = (response) => {
      this.setState({ customerList: response.data });
    };

    const handleFailure = (error) => {
      alert(JSON.stringify(error));
    };

    fetchCustomerGroups(handleSuccess, handleFailure);
  }

  handleFetchPromotions = (selectedCompany) => {
    const handleSuccess = (response) => {
      const { promotions } = response.data;
      const processPromo = _.map(promotions, promo => {
        if (promo.ProductListDetails && promo.ProductListDetails.length) {
          return {
            ...promo,
            Method: 'BuyMixAGetB',
            ProductNum: 'Mix Products'
          }
        }
        return promo
      });
      const rows = lodashFilter(processPromo, promotion => promotion.Method === this.state.tabsKey);
      const promotionsTableData = { ...this.state.promotionsTableData, rows };
      this.setState({
        isLoadingPromotions: false,
        promotions: processPromo,
        promotionsTableData,
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingPromotions: false });
      alert(JSON.stringify(error));
    };
    this.setState({ isLoadingPromotions: true }, () => {
      fetchPromotions(handleSuccess, handleFailure, selectedCompany);
    });
  };
  
  handleFetchGroups = () => {
    const handleSuccess = (groups) => {
      this.setState({
        isLoadingPromotions: false,
        groupList: groups,
        categoryList: [],
        selectedGroup: '',
        selectedCategory: '',
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingPromotions: false });
      alert(JSON.stringify(error));
    };
    this.setState({ isLoadingPromotions: true }, () => {
      fetchGroups(handleSuccess, handleFailure);
    });
  };
  
  handleFetchGroupCategories = (group_id) => {
    const handleSuccess = (categories) => {
      this.setState({
        isLoadingPromotions: false,
        categoryList: categories,
        selectedCategory: '',
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingPromotions: false });
      alert(JSON.stringify(error));
    };
    this.setState({ isLoadingPromotions: true }, () => {
      fetchGroupCategories(group_id, handleSuccess, handleFailure);
    });
  };

  openConfirmProductRepeat = () => {
    this.setState({ confirmProductRepeatOpen: true });
  }
  closeConfirmProductRepeat = () => {
    this.setState({ confirmProductRepeatOpen: false });
  }
  handleSavePromotionConfirm = () => {
    let promotionLine;
    let noDupes = true;
    switch (this.state.tabsKey) {
      case 'ByQuantity':
        promotionLine = desiredShapeByQuantity(this.state);
        break;
      case 'BuyAGetB':
      case 'BuyMixAGetB':
        const state = {
          ...this.state,
        }
        if (this.state.tabsKey === 'BuyMixAGetB') {
          state.selectedProductB = this.state.selectedProductMixA[0];
        }
        promotionLine = desiredShapeBuyAGetB(state);
        break;
      case 'ByTotalPriceProduct':
        promotionLine = desiredShapeByTotalPriceProduct(this.state);
        break;
      case 'ByTotalPriceDiscount':
        promotionLine = desiredShapeByTotalPriceDiscount(this.state);
        break;
      default:
        break;
    }
    if (this.state.promotions && this.state.promotions.length > 0) {
      this.state.promotions.map((r) => {
        if (r.Product_id === promotionLine.Product_id) {
          noDupes = false;
          this.openConfirmProductRepeat();
        }
      });
    }
    if (noDupes === true) {
      this.handleSavePromotion();
    }
  }

  handleSavePromotion = () => {
    const handleSuccess = () => {
      this.setState({ isLoadingSavePromotion: false }, () => {
        const state = clearForm(this.state);
        this.handleFetchPromotions(this.props.selectedCompany);
        this.setState(state);
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingSavePromotion: false });
      alert(JSON.stringify(error));
    };
    let promotionLine;
    switch (this.state.tabsKey) {
      case 'ByQuantity':
        promotionLine = desiredShapeByQuantity(this.state);
        break;
      case 'BuyAGetB':
      case 'BuyMixAGetB':
        const state = {
          ...this.state,
        }
        if (this.state.tabsKey === 'BuyMixAGetB') {
          state.selectedProductA = this.state.selectedProductMixA[0];
        }
        promotionLine = desiredShapeBuyAGetB(state);
        // promotionLine = desiredShapeBuyAGetB(this.state);
        break;
      case 'ByTotalPriceProduct':
        promotionLine = desiredShapeByTotalPriceProduct(this.state);
        break;
      case 'ByTotalPriceDiscount':
        promotionLine = desiredShapeByTotalPriceDiscount(this.state);
        break;
      default:
        break;
    }
    this.setState({ isLoadingSavePromotion: true }, () => {
      savePromotion(promotionLine, handleSuccess, handleFailure, this.props.selectedCompany);
    });
  }

  handleOpenEditPromotion = (promotionLineId) => {
    const handleSuccess = (response) => {
      const data = {
        ...response.data,
      };
      if (data.ProductListDetails && data.ProductListDetails.length) {
        data.Method = 'BuyMixAGetB';
      }
      this.setState({
        isLoadingPromoDetails: false,
        promotionToEdit: data,
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingPromoDetails: false });
      alert(JSON.stringify(error));
    };

    this.setState({ isLoadingPromoDetails: true }, () => {
      this.openEditPromotion();
      fetchPromoDetails(promotionLineId, handleSuccess, handleFailure);
    });
  }

  handleDeletePromotion = () => {
    const handleSuccess = () => {
      this.handleFetchPromotions(this.props.selectedCompany);
    };

    const handleFailure = (error) => {
      alert(JSON.stringify(error));
    };

    const { promotionToDeleteId } = this.state;
    deletePromotion(promotionToDeleteId, handleSuccess, handleFailure);
  }

  handleTabSelect = (key) => {
    if (this.state.isLoadingSavePromotion) {
      return;
    }
    const rows = lodashFilter(this.state.promotions, row => row.Method === key);
    const promotionsTableData = { ...this.state.promotionsTableData, rows };
    this.setState({ tabsKey: key, promotionsTableData });
  }

  handleSelectionChange = (value, fieldName) => {
    this.setState({ [fieldName]: value });
  }

  handlePriceLevelChange = (fieldName) => {
    if (this.state[[fieldName]] === true) {
      this.setState({ [fieldName]: false });
    } else {
      this.setState({ [fieldName]: true});
    }
  }

  handleOptionChange = (changeEvent, productSearchType) => {
    this.setState({ [productSearchType]: changeEvent.target.value });
  }

  getTwoDecimal = (number) => {
    return  Math.trunc(number*100)/100
  }

  handleDiscountButtonClick = (discountType, product) => {
    // let promotedPrice = this.state.promotedPrice;
    // if (discountType === 'Dollar' && product) {
    //   promotedPrice = this.getTwoDecimal(product.posUnitPrice - this.state.discountValue)
    // }
    // if (discountType === 'Percent') {
    //   promotedPrice = '';
    // }
    this.setState({ discountType }, () => {
      this.calculatePromotedPrice(this.state.discountValue, product);
    });
  }

  handleProductSuggestChange = (e, newValue, fieldName) => {
    // console.log('newValue: ',newValue); // value
    // console.log('fieldName: ',fieldName); // suggestValue
    
    this.setState({ [fieldName]: newValue });
  }

  handleClearButtonClick = (selectedProductName, suggestValueName) => {
    this.setState({ [selectedProductName]: {}, [suggestValueName]: '' });
  }

  handleDuplicateProductAClick = () => {
    const { selectedProductA } = this.state;
    this.setState({ selectedProductB: selectedProductA });
  }

  handleTextInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCheckBoxChange = (event) => {
    if (event.target.name === 'IsOneTime' && this.state[event.target.name] === false) {
      this.setState({ autoApply: false });
    }
    this.setState({ [event.target.name]: !this.state[event.target.name] });
  }

  handleGridSort = (sortColumn, sortDirection) => {
    const promotionsTableData = Object.assign({}, this.state.promotionsTableData, { sortColumn, sortDirection });
    this.setState({ promotionsTableData });
  };

  handleFilterChange = (filter) => {
    const newFilters = Object.assign({}, this.state.promotionsTableData.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    const promotionsTableData = { ...this.state.promotionsTableData, filters: newFilters };
    this.setState({ promotionsTableData });
  };

  handleClearFilters = () => {
    const promotionsTableData = { ...this.state.promotionsTableData, filters: {} };
    this.setState({ promotionsTableData });
  };

  selectInventoryInfo = (productNum, selectedInventoryRow, selectedProduct) => {
    const product = cleanProduct(selectedInventoryRow) 
    this.setState({
      [selectedProduct]: product,
      suggestValue: '',
      promotedPrice: '',
    });
  }

  selectInventoryInfoMix = (productNum, selectedInventoryRow, selectedProduct) => {
    const product = cleanProduct(selectedInventoryRow) 
    const selectedProductMixA = [...this.state.selectedProductMixA];
    selectedProductMixA.push(product);
      this.setState({
        selectedProductMixA: selectedProductMixA,
        suggestValue: '',
    })
  };

  handleMixARemove = (idx) => {
    const selectedProductMixA = [...this.state.selectedProductMixA];
    selectedProductMixA.splice(idx, 1);
    this.setState({
      selectedProductMixA,
    })
  }

  handleGroupChange = (group) => {
    if (group === -1) {
      this.handleSelectionChange(group, 'selectedGroup');
      this.setState({
        // isLoadingPromotions: false,
        categoryList: [{ value: -1, label: <Translate value="all" />  }],
        selectedCategory: -1,
      });
    } else {
      this.handleFetchGroupCategories(group);
      this.handleSelectionChange(group, 'selectedGroup');
    }
  }

  setPromotedPrice = (promotedPrice, product) => {
    // promoted price change calculate discount
    const { paymentTypeSelected, discountType } = this.state;
    let discountValue = '';
    if (discountType === 'Dollar') {
      if (paymentTypeSelected === 'POS') {
        discountValue = this.getTwoDecimal(product.posUnitPrice - promotedPrice);
      } else {
        discountValue = this.getTwoDecimal(product.currentRefPrice - promotedPrice);
      }
    } else {
      // Percentage
      if (paymentTypeSelected === 'POS') {
        discountValue = this.getTwoDecimal((product.posUnitPrice - promotedPrice)/product.posUnitPrice * 100)
      } else {
        discountValue = this.getTwoDecimal((product.currentRefPrice - promotedPrice)/product.currentRefPrice * 100)
      }
    }
    this.setState({ promotedPrice, discountValue })
  }
  
  calculatePromotedPrice = (discount, product) => {
    // on discount change calcualate promoted price
    const { paymentTypeSelected, discountType } = this.state;
    let promotedPrice = "";
    if (discountType === 'Dollar') {
      if (paymentTypeSelected === 'POS') {
        promotedPrice = this.getTwoDecimal(product.posUnitPrice - discount)
      } else {
        promotedPrice = this.getTwoDecimal(product.currentRefPrice - discount)
      }
    } else {
      // Percentage
      if (paymentTypeSelected === 'POS') {
        promotedPrice = this.getTwoDecimal(product.posUnitPrice * (100 - discount)/100)
      } else {
        promotedPrice = this.getTwoDecimal(product.currentRefPrice * (100 - discount)/100)
      }
    }
    this.setState({ promotedPrice });
  }

  renderByQuantityPromoDetails = () => (
    <div className="promo-section">
      <PromotionSetup
        setStartDate={this.setStartDate}
        startDateSelected={this.state.startDateSelected}
        setEndDate={this.setEndDate}
        endDateSelected={this.state.endDateSelected}
        handleSelectionChange={this.handleSelectionChange}
        customerGroupSelected={this.state.customerGroupSelected}
        paymentTypeSelected={this.state.paymentTypeSelected}
        customerOptions={this.getCustomerOptions()}
      />
      <ByQuantityFields
        paymentTypeSelected={this.state.paymentTypeSelected}
        methodSelected={this.state.methodSelected}
        quantityFrom={this.state.quantityFrom}
        quantityTo={this.state.quantityTo}
        discountValue={this.state.discountValue}
        discountType={this.state.discountType}
        applyLv1={this.state.applyLv1}
        applyLv2={this.state.applyLv2}
        applyLv3={this.state.applyLv3}
        applyLv4={this.state.applyLv4}
        applyLv5={this.state.applyLv5}
        handlePriceLevelChange={this.handlePriceLevelChange}
        handleSelectionChange={this.handleSelectionChange}
        handleTextInputChange={this.handleTextInputChange}
        handleDiscountButtonClick={this.handleDiscountButtonClick}
        selectedProduct={this.state.selectedProduct}
        setDiscountValue={(value) => this.setState({ discountValue: value })}
        promotedPrice={this.state.promotedPrice}
        setPromotedPrice={this.setPromotedPrice}
        state={this.state}
        calculatePromotedPrice={this.calculatePromotedPrice}
      />
      <SpinnerButton
        bsStyle="success"
        className="save-button"
        // onClick={this.handleSavePromotion}
        onClick={this.handleSavePromotionConfirm}
        disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'ByQuantity')}
        loading={this.state.isLoadingSavePromotion}
        icon="fa-save"
        translation={<Translate value="save" />}
      />
    </div>
  );

  renderBuyAGetBPromoDetails = (type) => (
    <div className="promo-section">
      <PromotionSetup
        setStartDate={this.setStartDate}
        startDateSelected={this.state.startDateSelected}
        setEndDate={this.setEndDate}
        endDateSelected={this.state.endDateSelected}
        handleSelectionChange={this.handleSelectionChange}
        customerGroupSelected={this.state.customerGroupSelected}
        paymentTypeSelected={this.state.paymentTypeSelected}
        customerOptions={this.getCustomerOptions()}
      />
      <BuyAGetBFields
        methodSelected={this.state.methodSelected}
        productQuantityA={this.state.productQuantityA}
        productQuantityB={this.state.productQuantityB}
        discountValue={this.state.discountValue}
        discountType={this.state.discountType}
        handleSelectionChange={this.handleSelectionChange}
        handleDiscountButtonClick={this.handleDiscountButtonClick}
        handleTextInputChange={this.handleTextInputChange}
        promotedPrice={this.state.promotedPrice}
        // setPromotedPrice={(promotedPrice) => this.setState({ promotedPrice })}
        setDiscountValue={(value) => this.setState({ discountValue: value })}
        setPromotedPrice={this.setPromotedPrice}
        selectedProductB={this.state.selectedProductB}
        selectedProductA={this.state.selectedProductA}
        selectedProductMixA={this.state.selectedProductMixA}
        calculatePromotedPrice={this.calculatePromotedPrice}
        type={type}
      />
      <SpinnerButton
        bsStyle="success"
        className="save-button"
        // onClick={this.handleSavePromotion}
        onClick={this.handleSavePromotionConfirm}
        disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, type)}
        loading={this.state.isLoadingSavePromotion}
        icon="fa-save"
        translation={<Translate value="save" />}
      />
    </div>
  );

  renderByTotalPriceProductPromoDetails = () => (
    <div className="promo-section">
      <PromotionSetup
        setStartDate={this.setStartDate}
        startDateSelected={this.state.startDateSelected}
        setEndDate={this.setEndDate}
        endDateSelected={this.state.endDateSelected}
        handleSelectionChange={this.handleSelectionChange}
        customerGroupSelected={this.state.customerGroupSelected}
        paymentTypeSelected={this.state.paymentTypeSelected}
        customerOptions={this.getCustomerOptions()}
      />
      <ByTotalPriceProductFields
        editing={false}
        minPurchasePrice={this.state.minPurchasePrice}
        productQuantityB={this.state.productQuantityB}
        SalesType={this.state.SalesType}
        handleTextInputChange={this.handleTextInputChange}
        handleSelectionChange={this.handleSelectionChange}
      />
      <SpinnerButton
        bsStyle="success"
        className="save-button"
        // onClick={this.handleSavePromotion}
        onClick={this.handleSavePromotionConfirm}
        disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'ByTotalPriceProduct')}
        loading={this.state.isLoadingSavePromotion}
        icon="fa-save"
        translation={<Translate value="save" />}
      />
    </div>
  );

  renderByTotalPriceDiscountPromoDetails = () => (
    <div className="promo-section">
      <PromotionSetup
        setStartDate={this.setStartDate}
        startDateSelected={this.state.startDateSelected}
        setEndDate={this.setEndDate}
        endDateSelected={this.state.endDateSelected}
        handleSelectionChange={this.handleSelectionChange}
        customerGroupSelected={this.state.customerGroupSelected}
        paymentTypeSelected={this.state.paymentTypeSelected}
        customerOptions={this.getCustomerOptions()}
      />
      <ByTotalPriceDiscountFields
        minPurchasePrice={this.state.minPurchasePrice}
        discountValue={this.state.discountValue}
        discountType={this.state.discountType}
        SalesType={this.state.SalesType}
        handleDiscountButtonClick={this.handleDiscountButtonClick}
        handleTextInputChange={this.handleTextInputChange}
        handleSelectionChange={this.handleSelectionChange}
      />
      <SpinnerButton
        bsStyle="success"
        className="save-button"
        // onClick={this.handleSavePromotion}
        onClick={this.handleSavePromotionConfirm}
        disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, 'ByTotalPriceDiscount')}
        loading={this.state.isLoadingSavePromotion}
        icon="fa-save"
        translation={<Translate value="save" />}
      />
    </div>
  );

  renderByQuantityTab = () => {
    const byQuantityTitle = (<Translate value="by_quantity_discount" />);
    return (
      <Tab eventKey="ByQuantity" title={byQuantityTitle}>
        <div className="by-quantity-tab">
          <PromotionsProductSearch
            productSearchType={this.state.productSearchType}
            suggestValue={this.state.suggestValue}
            selectedProduct={this.state.selectedProduct}
            handleOptionChange={this.handleOptionChange}
            handleProductSuggestChange={this.handleProductSuggestChange}
            selectInventoryInfo={this.selectInventoryInfo}
            
            groupSearch={true}
            handleSelectionChange={this.handleSelectionChange}
            handleGroupChange={this.handleGroupChange}
            groupOptions={this.getGroupOptions()}
            categoryOptions={this.getCategoryOptions()}
            selectedGroup={this.state.selectedGroup}
            selectedCategory={this.state.selectedCategory}
          />
          <div className="divider" />
          { this.renderByQuantityPromoDetails() }
        </div>
      </Tab>
    );
  }

  renderBuyAGetBTab = () => {
    // const buyAGetBTitle = (<Translate value="buy_a_get_b" />);
    const buyAGetBTitle = (<Translate value="by_quantity_product" />);
    if (isGFD) return null;
    return (
      <Tab eventKey="BuyAGetB" title={buyAGetBTitle}>
        <div className="buy-a-get-b-tab">
          <BuyAGetBProductSearches
            productSearchTypeA={this.state.productSearchTypeA}
            suggestValueA={this.state.suggestValueA}
            selectedProductA={this.state.selectedProductA}
            productSearchTypeB={this.state.productSearchTypeB}
            suggestValueB={this.state.suggestValueB}
            selectedProductB={this.state.selectedProductB}
            handleOptionChange={this.handleOptionChange}
            handleProductSuggestChange={this.handleProductSuggestChange}
            selectInventoryInfo={this.selectInventoryInfo}
            handleClearButtonClick={this.handleClearButtonClick}
            handleDuplicateProductAClick={this.handleDuplicateProductAClick}
            
            handleSelectionChange={this.handleSelectionChange}
            handleGroupChange={this.handleGroupChange}
            groupOptions={this.getGroupOptions()}
            categoryOptions={this.getCategoryOptions()}
            selectedGroup={this.state.selectedGroup}
            selectedCategory={this.state.selectedCategory}
          />
          <div className="divider" />
          { this.renderBuyAGetBPromoDetails('BuyAGetB') }
        </div>
      </Tab>
    );
  }

  renderByMixGetBTab = () => {
    if (isGFD) {
    const buyAGetBTitle = (<Translate value="by_quantity_product_mix" />);
    return (
      <Tab eventKey="BuyMixAGetB" title={buyAGetBTitle}>
        <div className="buy-mix-a-get-b-tab">
          <BuyMixAGetBProductSearches
            handleMixARemove={this.handleMixARemove}
            productSearchTypeA={this.state.productSearchTypeA}
            suggestValueA={this.state.suggestValueA}
            selectedProductMixA={this.state.selectedProductMixA}
            productSearchTypeB={this.state.productSearchTypeB}
            suggestValueB={this.state.suggestValueB}
            selectedProductB={this.state.selectedProductB}
            handleOptionChange={this.handleOptionChange}
            handleProductSuggestChange={this.handleProductSuggestChange}
            selectInventoryInfo={this.selectInventoryInfo}
            selectInventoryInfoA={this.selectInventoryInfoMix}
            handleClearButtonClick={this.handleClearButtonClick}
            handleDuplicateProductAClick={this.handleDuplicateProductAClick}
            
            handleSelectionChange={this.handleSelectionChange}
            handleGroupChange={this.handleGroupChange}
            groupOptions={this.getGroupOptions()}
            categoryOptions={this.getCategoryOptions()}
            selectedGroup={this.state.selectedGroup}
            selectedCategory={this.state.selectedCategory}
          />
          <div className="divider" />
          { this.renderBuyAGetBPromoDetails('BuyMixAGetB') }
        </div>
      </Tab>
    )
    }
  }

  renderByTotalPriceProductTab = () => {
    const byTotalPriceProductTitle = (
      <span>
        <Translate value="by_total_price" /> (<Translate value="product" />)
      </span>
    );
    return (
      <Tab eventKey="ByTotalPriceProduct" title={byTotalPriceProductTitle}>
        <div className="by-total-price-product-tab">
          <div className="promo-code-section-product">
            <label htmlFor="promo-code" className="promo-code-label"><Translate value="promo_code" />:</label>
            <input
              id="promo-code-text-input-product"
              name="promoCode"
              className="text-input-field"
              type="text"
              value={this.state.promoCode}
              onChange={this.handleTextInputChange}
            />
            <div className="auto-apply-wrapper">
              <input
                id="auto-apply-checkbox"
                name="autoApply"
                type="checkbox"
                disabled={this.state.IsOneTime}
                checked={this.state.autoApply}
                onChange={this.handleCheckBoxChange}
              />
              <label htmlFor="auto-apply" className="auto-apply-label"><Translate value="auto_apply" /></label>
            </div>
            {
              (isOLG || isLMH || isSDR || isCRW || isSC) &&
              <div className="auto-apply-wrapper">
                <input
                  id="one-time-checkbox"
                  name="IsOneTime"
                  type="checkbox"
                  checked={this.state.IsOneTime}
                  onChange={this.handleCheckBoxChange}
                />
                <label htmlFor="one-time" className="one-time-label"><Translate value="one_time_use" /></label>
              </div>
            }
            {
              isAFM && 
              <div className="auto-apply-wrapper">
                <input
                  id="is-public-checkbox"
                  name="IsPublic"
                  type="checkbox"
                  checked={this.state.IsPublic}
                  onChange={this.handleCheckBoxChange}
                />
                <label htmlFor="is-public" className="is-public-label"><Translate value="is_public" /></label>
              </div>
            }  
          </div>
          <div className="divider" style={{marginRight: '10px'}}/>
          <PromotionsProductSearch
            productSearchType={this.state.productSearchType}
            suggestValue={this.state.suggestValue}
            selectedProduct={this.state.selectedProduct}
            handleOptionChange={this.handleOptionChange}
            handleProductSuggestChange={this.handleProductSuggestChange}
            selectInventoryInfo={this.selectInventoryInfo}
            
            groupSearch={false}
            handleSelectionChange={this.handleSelectionChange}
            handleGroupChange={this.handleGroupChange}
            groupOptions={this.getGroupOptions()}
            categoryOptions={this.getCategoryOptions()}
            selectedGroup={this.state.selectedGroup}
            selectedCategory={this.state.selectedCategory}
          />
          <div className="divider" />
          { this.renderByTotalPriceProductPromoDetails() }
        </div>
      </Tab>
    );
  }

  renderByTotalPriceDiscountTab = () => {
    const byTotalPriceDiscountTitle = (
      <span>
        <Translate value="by_total_price" /> (<Translate value="discount" />)
      </span>
    );
    return (
      <Tab eventKey="ByTotalPriceDiscount" title={byTotalPriceDiscountTitle}>
        <div className="by-total-price-discount-tab">
          <div className="promo-code-section">
            <label htmlFor="promo-code" className="promo-code-label"><Translate value="promo_code" />:</label>
            <input
              id="promo-code-text-input"
              name="promoCode"
              className="text-input-field"
              type="text"
              value={this.state.promoCode}
              onChange={this.handleTextInputChange}
            />
            <div className="auto-apply-wrapper">
              <input
                id="auto-apply-checkbox"
                name="autoApply"
                type="checkbox"
                disabled={this.state.IsOneTime}
                checked={this.state.autoApply}
                onChange={this.handleCheckBoxChange}
              />
              <label htmlFor="auto-apply" className="auto-apply-label"><Translate value="auto_apply" /></label>
            </div>   
            <div className="auto-apply-wrapper">
              <input
                id="one-time-checkbox"
                name="IsOneTime"
                type="checkbox"
                checked={this.state.IsOneTime}
                onChange={this.handleCheckBoxChange}
              />
              <label htmlFor="one-time" className="one-time-label"><Translate value="one_time_use" /></label>
            </div>
            {
              isAFM && 
              <div className="auto-apply-wrapper">
                <input
                  id="is-public-checkbox"
                  name="IsPublic"
                  type="checkbox"
                  checked={this.state.IsPublic}
                  onChange={this.handleCheckBoxChange}
                />
                <label htmlFor="is-public" className="is-public-label"><Translate value="is_public" /></label>
              </div>
            }
          </div>
          <div className="divider" />
          { this.renderByTotalPriceDiscountPromoDetails() }
        </div>
      </Tab>
    );
  }

  render() {
    const editPromotionDialog = {
      width: '750px',
      height: 'auto',
      marginLeft: '-20%',
      top: '40%',
    };
    const deletePromotionDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };
    const confirmProductRepeatStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };
    const confirmProductRepeatTitle = (<Translate value="duplicate_product" />);
    const editPromotionTitle = <Translate value="edit_promotion" />;
    const { isLoadingPromotions } = this.state;
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="sales_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="promotions" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <Grid id="promotions-page">
          <Row>
            <Tabs activeKey={this.state.tabsKey} justified onSelect={this.handleTabSelect}>
              { this.renderByQuantityTab() }
              { this.renderBuyAGetBTab() }
              {this.renderByMixGetBTab()}
              { this.renderByTotalPriceProductTab() }
              { this.renderByTotalPriceDiscountTab() }
            </Tabs>
          </Row>
          <Row>
            <Panel className="promotions-table-panel">
              {
                isLoadingPromotions &&
                  <Spinner />
              }
              <PromotionsTable
                promotions={this.state.promotionsTableData}
                tabsKey={this.state.tabsKey}
                handleGridSort={this.handleGridSort}
                handleFilterChange={this.handleFilterChange}
                openDeletePromotion={this.openDeletePromotion}
                handleOpenEditPromotion={this.handleOpenEditPromotion}
                handleClearFilters={this.handleClearFilters}
              />
            </Panel>
          </Row>
        </Grid>
        <SkyLightStateless
          dialogStyles={editPromotionDialog}
          isVisible={this.state.editPromotionOpen}
          onCloseClicked={() => this.closeEditPromotion()}
          title={editPromotionTitle}
        >
          <EditPromotionModal
            promotion={this.state.promotionToEdit}
            customerList={this.state.customerList}
            closeEditPromotion={this.closeEditPromotion}
            isLoadingPromoDetails={this.state.isLoadingPromoDetails}
            selectedCompany={this.props.selectedCompany}
            getGroupOptions={this.getGroupOptions}
            getCategoryOptions={this.getCategoryOptions}
            handleFetchGroupCategories={this.handleFetchGroupCategories}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={deletePromotionDialogStyle}
          isVisible={this.state.deletePromotionOpen}
          onCloseClicked={this.closeDeletePromotion}
        >
          <ConfirmActionModal
            case="removeItem"
            closeC={this.closeDeletePromotion}
            caseAction={this.handleDeletePromotion}
          />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={confirmProductRepeatStyle}
          isVisible={this.state.confirmProductRepeatOpen}
          onCloseClicked={this.closeConfirmProductRepeat}
          title={confirmProductRepeatTitle}
        >
          <ConfirmActionModal
            case="confirmProductRepeat"
            closeC={this.closeConfirmProductRepeat}
            caseAction={this.handleSavePromotion}
          />
        </SkyLightStateless>

      </ContentWrapper>
    );
  }
}

// PromotionsPage.propTypes = propTypes;
// PromotionsPage.defaultProps = defaultProps;

export default PromotionsPage;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/PromotionsPage.jsx